import { z } from 'zod';

export const getImpactAnswersDtoSchema_MobilityPublic = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    transportationMode: z.string(),
    passengerCount: z.string().or(z.number()),
    travelDistance: z.string(),
    departurePoint: z.string(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionMobilityPublicDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  transportationMode: string;
  passengerCount: string | number; // received in string but sent in number
  travelDistance: string | number; // received in string but sent in number
  departurePoint: string;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  tags?: { values?: Array<{ id: number; name: string }> };
};
